import { of, zip } from "rxjs";
import {
  distinctUntilChanged,
  filter,
  groupBy,
  map,
  mergeMap,
  switchMap,
} from "rxjs/operators";

export const MaterialSystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),
      mergeMap((group$) =>
        group$.pipe(
          // filter non
          filter(
            (entity) => entity.hasOwnProperty("object3D") && entity.object3D
          ),

          // insert object3D
          switchMap((definition) => {
            if (definition.object3D) {
              return world.object3DManager
                .getObject3D$(definition.object3D)
                .pipe(map((object3D) => ({ definition, object3D })));
            } else {
              return of({ definition });
            }
          }),

          // Use default material name (defined in mesh)
          // if definition.material === undefined
          map((result) => {
            if (
              result.object3D &&
              result.object3D.material &&
              result.object3D.material.name &&
              !result.definition.material
            ) {
              result.definition = {
                ...result.definition,
                material: result.object3D.material.name,
              };
            }
            return result;
          }),

          filter((result) => result.definition.hasOwnProperty("material")),

          // false --> pass
          distinctUntilChanged(
            (prev, curr) =>
              prev.definition.material === curr.definition.material &&
              prev.object3D === curr.object3D
          ),

          // insert material
          switchMap((result) => {
            const { definition } = result;
            if (definition.material) {
              if (Array.isArray(definition.material)) {
                return zip(
                  ...definition.material.map((id) =>
                    world.materialManager.getMaterial$(id)
                  )
                ).pipe(map((material) => ({ ...result, material })));
              } else {
                return world.materialManager
                  .getMaterial$(definition.material)
                  .pipe(map((material) => ({ ...result, material })));
              }
            } else {
              return of(result);
            }
          })
        )
      )
    )

    .subscribe((result) => {
      const { object3D, material } = result;
      if (object3D && material && object3D.material !== material) {
        object3D.material = material;
      }
      world.change$.next();
    });
};

export default MaterialSystem;
